import React from "react";
import { User, Settings, LogOut, Bell, HelpCircle, Crown, Shield, DollarSign } from "lucide-react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useAuth } from "../contexts/AuthContext";
import { useListContext } from "../contexts/ListContext";
import { useNavigate } from "react-router-dom";

const HamburgerMenu = ({ isOpen, onClose }) => {
  const { user, logout } = useAuth();
  const { saveNow } = useListContext();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await saveNow();
    logout();
  };

  const menuItems = [
    { icon: Crown, label: "Subscription", action: () => navigate("/subscription") },
    { icon: DollarSign, label: "My Earnings", action: () => navigate("/earnings") },
    ...(user?.role === "admin" ? [{ icon: Shield, label: "Admin Dashboard", action: () => navigate("/admin") }] : []),
    { icon: Bell, label: "Notifications", action: () => navigate("/notifications") },
    { icon: Settings, label: "Settings", action: () => navigate("/settings") },
    { icon: HelpCircle, label: "Help & Support", action: () => navigate("/support") },
    { icon: LogOut, label: "Logout", action: handleLogout, danger: true },
  ];

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-80 bg-white">
        <SheetHeader>
          <SheetTitle className="text-left text-black">Menu</SheetTitle>
        </SheetHeader>
        
        <div className="mt-8">
          {/* User Section */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6" data-testid="menu-user-section">
            <div className="flex items-center gap-3">
              {user?.avatar_url ? (
                <img
                  src={user.avatar_url}
                  alt={user.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-green-400 bg-gray-100"
                  data-testid="menu-avatar"
                />
              ) : (
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <User className="h-6 w-6 text-white" />
                </div>
              )}
              <div className="min-w-0">
                <p className="font-semibold text-black truncate" data-testid="menu-user-name">
                  {user?.name || "Guest"}
                </p>
                <p className="text-sm text-gray-600 truncate" data-testid="menu-user-email">
                  {user?.email || ""}
                </p>
              </div>
            </div>
          </div>

          {/* Menu Items */}
          <div className="space-y-2">
            {menuItems.map(({ icon: Icon, label, action, danger }) => (
              <Button
                key={label}
                variant="ghost"
                className={`w-full justify-start gap-3 py-3 h-auto ${
                  danger 
                    ? "text-red-600 hover:text-red-700 hover:bg-red-50" 
                    : "text-gray-700 hover:bg-gray-100"
                }`}
                onClick={() => {
                  action();
                  onClose();
                }}
                data-testid={`menu-${label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <Icon className="h-5 w-5" />
                {label}
              </Button>
            ))}
          </div>

          {/* App Info */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center">
              Foodz Lizts v1.0.0
            </p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default HamburgerMenu;
